import React from "react";
import classNames from "classnames";
import { COMMUNITY_TABLE_HEADERS } from "utils/communities/constants";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import classes from "./styles.module.scss";
import sharedClasses from "../styles.module.scss";

const SavingsByMeasureTable = ({ visibleTableData = [], isEnviroCentreUser = false }) => {
    return (
        <Table className={classes.savingsTable}>
            <TableHead
                className={classNames(classes.savingsTableHead, sharedClasses.stickyHeader, {
                    [classes.enviroCentre]: isEnviroCentreUser,
                })}
            >
                <TableRow>
                    <TableCell style={{ width: "175px" }}>Measure Category</TableCell>
                    <TableCell>Electricity Savings(kWh)</TableCell>
                    <TableCell>Natural Gas Savings (m³)</TableCell>
                    <TableCell>Propane Savings (L)</TableCell>
                    <TableCell>Oil Savings (L)</TableCell>
                    <TableCell>Total Energy Savings without PV (GJ)</TableCell>
                    <TableCell>Total Energy Savings with PV (GJ)</TableCell>
                    <TableCell>Total Emissions Savings (tCO₂)</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {visibleTableData.map(
                    (
                        {
                            elecSavingsKWH,
                            gasSavingsM3,
                            propaneSavingsL,
                            oilSavingsL,
                            aecSavingsGJ,
                            netSavingsGJ,
                            emissionsSavingsTCO2,
                            upgradeType,
                        },
                        index
                    ) => {
                        const cellValues = [
                            elecSavingsKWH.toFixed(2),
                            gasSavingsM3.toFixed(2),
                            propaneSavingsL.toFixed(2),
                            oilSavingsL.toFixed(2),
                            aecSavingsGJ.toFixed(2),
                            netSavingsGJ.toFixed(2),
                            emissionsSavingsTCO2.toFixed(2),
                        ];

                        return (
                            <TableRow key={`measure-${index}`} className={classes.savingsTableRow}>
                                <TableCell className={classes.measureColumn}>
                                    {COMMUNITY_TABLE_HEADERS[upgradeType]}
                                </TableCell>
                                {cellValues.map((value, cellIndex) => (
                                    <TableCell
                                        key={`cell-${cellIndex}`}
                                        className={classNames({
                                            [classes.noValue]: value == 0,
                                            [classes.negValue]: value < 0,
                                            [classes.posValue]: value > 0,
                                            [classes.enviroCentre]: isEnviroCentreUser,
                                            [classes.cellWithPadding]: true,
                                        })}
                                    >
                                        {value}
                                    </TableCell>
                                ))}
                            </TableRow>
                        );
                    }
                )}
                {visibleTableData.length === 0 && (
                    <TableRow>
                        <TableCell colSpan={8} className={classes.noData}>
                            There is no data available for these selected models and upgrade package.
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    );
};

export default SavingsByMeasureTable;
